import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';

// Services
import { SharedDataService } from 'app/services/shared-data.service';
import { CompanyService } from 'app/services/company.service'
import { AnalyticsService } from './analytics.service'
// Interfaces
import { User } from '../interfaces/user'
import { Message } from '../interfaces/message'
import { Company } from 'app/interfaces/company';
import { NotificationService } from './notification.service';
import { NegotiationService } from './negotiation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private errorMessage = new Subject<Message>();
  public ipdvUrl: any

  httpOptions = {
    headers: new HttpHeaders({ 'tenantId': '01,01' })
  }

  constructor(
    private httpClient: HttpClient,
    private sharedService: SharedDataService,
    private companyService: CompanyService,
    private analytics: AnalyticsService,
    private route: Router,
    private notifyService: NotificationService,
    private notificationService: NotificationService,
    private negotiationService: NegotiationService
  ) { }

  login(loginData: User): Observable<Message> {
    this.httpClient.post<User>('/security/login', loginData, this.httpOptions).pipe(first())
      .subscribe(
        data => {
          // @ts-ignore
          if (data.msg.forceChgPsw) {
            // @ts-ignore
            localStorage.setItem('currentUser', JSON.stringify({ login: data.login  }));
            this.route.navigate(['/pages/change-password'])
          } else {
            localStorage.setItem('currentUser', JSON.stringify(data));
            this.sharedService.setRegionId(data.regionId)
            this.sharedService.setTokenId(data.tokenId)
            this.getToken(data)
            this.companyService.fetchCompany().pipe(first()).subscribe(
              company => {
                this.companyService.companySelected(company[0])
                const TenantId = company[0].companyId + company[0].branchId
                this.handleAnalytics(TenantId, company)
                this.handleNavigate(TenantId, company)
              }
            )

            // @ts-ignore
            this.notificationService.showNotification('top', 'left', 'success', data.msg.txt)
            
            // setTimeout(() => {
            //   // location.reload()
            // }, 3000);
          }

        }, error => {
          this.errorMessage.next(error)
        }
      )
    return this.errorMessage.asObservable()
  }

  async getToken(login: any) {
    const payload = {
      login: "user-api",
      senha: "yi$kHX&FidEKL3s@VeS1v2#UvPKR"
    }

    const result = await this.negotiationService.getTokenIPDV(payload)
    this.generateUrl(login, result)
  }

  async generateUrl(login: any, token: any) {
    const payload = {
      token: token.token,
      email: login.email.trim()
    }

    const result = await this.negotiationService.generateUrl(payload)
    this.ipdvUrl = result.url
    localStorage.setItem('ipdvUrl', result.url)
  }

  logout() {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('ipdvUrl')
    this.route.navigate([''])
  }

  userIsAuthenticated() {
    return localStorage.getItem('currentUser') !== null
  }

  handleNavigate(TenantId: string, company: Company[]) {
    const urlRef = localStorage.getItem('urlReference')
    const navigateTo = urlRef && (company.some(comp => urlRef.includes(comp.companyId + comp.branchId))) ? urlRef : TenantId + '/dashboard'

    this.route.navigate([navigateTo]).then(() => {
      if (urlRef && !(company.some(comp => urlRef.includes(comp.companyId + comp.branchId)))) {
        localStorage.removeItem('urlReference')
        this.notifyService.showErrorNotification('Você não tem Permissão para acessar este documento.', 'Entendi')
      }
    })
  }

  handleAnalytics(TenantId: string, company) {
    const attributes = { tenantId: TenantId.toString(), companyName: company[0].companyName, automaticallySetted: 'true' }
    this.analytics.recordCustomEventWithAttributes('SelectCompany', attributes)
  }

  policyRead() {
    return this.httpClient.get<any>(`$companyId/security/acceptPol`)
  }

}
